(() => {
  const form = document.getElementById('ProApplication');
  const registration = form?.elements.namedItem('contact[Immatriculation]');
  const country = form?.elements.namedItem('contact[Pays]');
  const label = form?.querySelector('[data-registration-label]');
  if (!registration || !country || !label || registration.dataset.formatReady) return;
  registration.dataset.formatReady = 'true';
  const otherCountry = form.querySelector('[data-country-other]');

  const update = () => {
    const other = country.selectedOptions[0]?.dataset.countryCode === 'other';
    otherCountry.hidden = !other;
    otherCountry.querySelector('input').disabled = !other;
    otherCountry.querySelector('input').required = other;
    const france = ['france', 'fr', 'fra', 'francia', 'frankreich'].includes(country.value.trim().toLowerCase());
    const digits = registration.value.replace(/\s/g, '');
    const invalid = france && registration.value !== '' && !/^(?:[0-9]{9}|[0-9]{14})$/.test(digits);
    registration.setCustomValidity(invalid ? registration.dataset.formatError : '');
    registration.inputMode = france ? 'numeric' : 'text';
    registration.placeholder = france ? registration.dataset.frenchPlaceholder : registration.dataset.internationalPlaceholder;
    label.textContent = `${france ? label.dataset.frenchLabel : label.dataset.internationalLabel} *`;
  };

  registration.addEventListener('input', update);
  registration.addEventListener('change', update);
  country.addEventListener('input', update);
  country.addEventListener('change', update);
  update();
})();
